// @ts-strict-ignore
/** @jsx jsx */
import { jsx, useThemeUI } from 'theme-ui'

import { path } from '../../utils/obj'

import { Container } from '@uswitch/ev-core/react'
import HeroWithBackgroundImg from '@uswitch/ev-components/lib/components/compounds/hero-with-background-img'

import Breadcrumbs from '../breadcrumbs.connected'
import Grid from './grid-from-json.connected'
import { useEntity } from '../helpers/use-entity'

const WrappedHeroWithBackgroundImg = ({ breadcrumbs, content, image, layout }) => {
  const { theme } = useThemeUI()
  const imageEntity = useEntity(image)
  const { contentCols = 12, contentSpan = 12 } = path(
    ['modules', 'hero-with-background-image', 'layout'],
    theme,
    {},
  )

  const breadcrumbComponent = (
    <If condition={breadcrumbs}>
      <Breadcrumbs entity={breadcrumbs} variant='light' />
    </If>
  )

  const containerStyles = {
    '> *': {
      height: '100%',
      alignContent: breadcrumbs ? 'space-between' : 'flex-end',
    },
  }

  return (
    <HeroWithBackgroundImg imageUrl={imageEntity.file.url}>
      <Container cols={contentCols} span={contentSpan} sx={containerStyles}>
        <Grid prependContent={breadcrumbComponent} content={content} layout={layout} />
      </Container>
    </HeroWithBackgroundImg>
  )
}

export default WrappedHeroWithBackgroundImg
